import { format } from 'date-fns';
import { useState } from 'react';

export default function useExportRequest(modelType, getters) {
    const [exporting, setExporting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const executeExport = () => {
        setExporting(true);
        setSuccess(false);

        const upperCaseModel = modelType.toUpperCase();
        try{
            const version = process.env[`REACT_APP_${upperCaseModel}_VERSION`];
            if (!version) {
                throw `File save error: Version for ${upperCaseModel} model is unknown`;
            }
            const url = URL.createObjectURL(new Blob([JSON.stringify({ pricer: modelType, pricerVersion: version, ...getters }, null, 2)], {type: 'application/json',}));
            const anchor = document.createElement('a');
            const fileName = `${getters.claimId} ${modelType} ${format(new Date(), 'yyyy-MM-dd')}.mrpreq`;
            anchor.download = fileName
            anchor.href = url;
            anchor.addEventListener('click', () => {
                setTimeout(() => URL.revokeObjectURL(url), 30 * 1000);
                setExporting(false);
                setSuccess(true);
            });
            anchor.click();
        } catch (error) {
            if (typeof error === 'string') {
                setError(error);
            } else {
                setError(`File save error: ${error.message}`);
            }
            setExporting(false);
            setSuccess(false);
        }
    };
    
    const executeReset = () => {
        setExporting(false);
        setSuccess(false);
        setError(null);
    }
    return [exporting, success, error, executeExport, executeReset];
  }